<script>
export default {
  name: 'ApiProperty',

  props: {
    data: {
      type: Object,
      required: true,
    },

    isNestedProperty: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="api-property-wrapper">
    <div class="api-property">
      <div class="header">
        <span class="name">{{ data.propertyName }}</span>

        <span class="type">
          {{ data.type }}
        </span>

        <span v-if="data.necessity" :class="[data.necessity.toLowerCase()]">
          {{ data.necessity }}
        </span>
      </div>
      <p class="description">{{ data.description }}</p>
    </div>

    <div class="nested-properties" v-if="data.nestedProperties && !isNestedProperty">
      <ApiProperty
        v-for="prop in data.nestedProperties"
        :key="prop.sys.id"
        :data="prop.fields"
        :isNestedProperty="true"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.api-property {
  @include caption-regular;
  margin: $space-12 0;
  padding-bottom: $space-12;
  border-bottom: 1px solid $separator-color;

  &:last-of-type {
    margin-bottom: 0;
  }

  .header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .name {
      font-family: $font-family-code;
      margin-right: $space-16;
      background-color: $code-block-background-color-tertiary;
      color: $text-color-tertiary;
      border-radius: $border-radius-xx-small;
      padding: $space-8;
    }

    span {
      margin-bottom: 4px;

      @include tablet-large {
        margin-top: 0;
      }
    }

    .required {
      font-weight: $font-weight-bold;
      color: $alert-color-red;

      @include tablet-large {
        margin-left: auto;
      }
    }

    .optional {
      font-weight: $font-weight-bold;
      color: $text-color-secondary;

      @include tablet-large {
        margin-left: auto;
      }
    }

    .type {
      font-weight: $font-weight-bold;
      color: $text-color-secondary;
      margin-right: $space-16;
    }
  }

  .description {
    margin: $space-12 0 0;
    font-weight: 300;
  }
}

.nested-properties {
  padding: 0 0 $space-12 $space-16;
  border-bottom: 1px solid $separator-color;

  @include tablet-large {
    padding: 0 0 $space-12 $space-32;
  }

  .api-property-wrapper {
    margin-top: $space-12;

    .header {
      .name {
        color: $text-color-primary;
        background-color: $background-color-secondary;
      }
    }

    &:last-of-type {
      .api-property {
        padding-bottom: 0;
        border-bottom: none;
      }
    }
  }
}

@media print {
  .api-property {
    .header {
      .name {
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }

      .type,
      .optional {
        color: $text-color-primary;
      }
    }
  }
}
</style>
